import { Component, OnInit, AfterViewInit } from '@angular/core';
declare var AOS: any;
@Component({ selector: 'app-sol-safety-alerts', templateUrl: './safety-alerts.component.html', styleUrls: ['./safety-alerts.component.scss'], standalone: false })
export class SafetyAlertsComponent implements OnInit, AfterViewInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Features', icon: 'bx-shield' },
    { id: 'outcomes', label: 'How It Works', icon: 'bx-cog' },
  ];
  features = [
    { icon: 'bx-car', title: 'Crash Detection', desc: 'AI-powered crash detection triggers immediate emergency alerts to family and emergency services.' },
    { icon: 'bx-user-voice', title: 'SOS Button', desc: 'One-press SOS with live location sharing and two-way communication with emergency responders.' },
    { icon: 'bx-map-pin', title: 'Geo-Fencing', desc: 'Define safe zones and get instant alerts when your vehicle leaves or enters designated areas.' },
    { icon: 'bx-trending-up', title: 'Speed Alerts', desc: 'Configurable speed threshold notifications to monitor young or new drivers in real time.' },
    { icon: 'bx-time-five', title: 'Curfew Alerts', desc: 'Get notified if your vehicle is used outside pre-set time windows — ideal for family safety.' },
    { icon: 'bx-analyse', title: 'Driver Risk Score', desc: 'Ongoing driver risk rating based on harsh braking, sharp cornering, and speed patterns.' },
  ];
  ngOnInit() {}
  ngAfterViewInit() { try { AOS.refresh(); } catch (e) {} }
  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
